<!-- eslint-disable max-len -->
<template>
  <div class="main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll">

    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div
          class="bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
        >
          <h5 class="font-bold uppercase text-gray-600">Stream </h5>
        </div>
        <div class="overflow-y-auto">
          <div style="margin-bottom: 10px">
            <el-row class="px-5 py-2 " >
              <el-col :span="18">
                <el-row>
                  <el-col :span="10" class="flex flex-col mr-5">
                    <span class="text-left">Filter Date</span>
                    <date-range-picker
                      ref="picker"
                      :timePicker="false"
                      :showDropdowns="false"
                      :max-date="maxDate"
                      v-model="dateRange"
                      :opens="'right'"
                      @update="onChangeDate"
                      :auto-apply="true"
                    >
                      <template v-slot:input="picker" >
                        From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                      </template>
                    </date-range-picker>
                  </el-col>
                  <el-col :span="10" class="flex flex-col">
                    <span class="text-left">Search</span>
                    <input placeholder="search song name" v-model="filter.q" @change="search" class="border border-grey-light w-full p-3 rounded" />
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row class="flex justify-end">
                  <el-col :span="24" class="flex flex-row">
                    <div class="bg-transparent w-full">
                      <div class="card cursor-pointer border border-gray-400 rounded-lg">
                        <div class="m-3">
                          <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Current Stream</h2>
                          <div class="text-4xl text-center text-black font-bold">{{streamCurrentTotal}}</div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>

          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
          </data-tables-server>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

const displayingItems = 50;

export default {
  name: 'StreamListPage',
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'title',
        label: 'Song Name',
      }, {
        prop: 'category',
        label: 'Category',
      }, {
        prop: 'albums',
        label: 'Album',
      }, {
        prop: 'year',
        label: 'Year',
      }, {
        prop: 'total_stream',
        label: 'Total Stream',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        q: '',
        sortby: 'music.created_at',
        sortorder: 'desc',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListStream(this.filter);
  },
  computed: {
    ...mapGetters('TransactionModule', ['listStream', 'streamCurrentTotal']),
  },
  watch: {
    listStream: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.listStream.data !== undefined) {
          this.data = this.listStream.data.data.map(credit => ({ ...credit, price_dollar_text: `$${parseFloat(credit.price_dollar).toFixed(2)}` }));
          this.total = this.listStream.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('TransactionModule', ['requestListStream']),
    async search() {
      await this.requestListStream(this.filter);
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'music.created_at',
        sortorder: 'desc',
        q: '',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'music.created_at';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListStream(this.filter);
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.search();
    },
  },
  components: {
    VueCustomTooltip, DateRangePicker,
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
.vue-daterange-picker .reportrange-text{
  padding: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/StreamList.vue